export default __webpack_public_path__ + "static/media/logo_circle.bd038b14.png";